const map = {
	"./EmployeeData.json": [
		50151,
		[
			151
		]
	],
	"./SearchForAnEmployee.json": [
		39709,
		[
			9709
		]
	],
	"./SearchForClient.json": [
		64821,
		[
			4821
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68146;
module.exports = webpackAsyncContext;